import { createFileRoute, Link, useSearch } from '@tanstack/react-router'
import { JudgeProfileView } from '@workspace/seedforge-ui/evaluation'
import { Loader2 } from 'lucide-react'
import { useAdminJudgeProfileQuery } from '../../../features/admin/hooks/use-admin-api'

export const Route = createFileRoute('/admin/evaluations/$id/judge/$judgeKey')({
  component: AdminJudgePage,
  validateSearch: (search: Record<string, unknown>) => ({
    startupId: (search.startupId as string) ?? '',
  }),
})

function AdminJudgePage() {
  const { id, judgeKey } = Route.useParams()
  const { startupId } = useSearch({ from: Route.fullPath })
  const { data, isLoading, error } = useAdminJudgeProfileQuery(startupId, id, judgeKey)

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Loader2 className="size-6 animate-spin text-muted-foreground" />
      </div>
    )
  }

  if (error || !data?.data) {
    return (
      <div className="flex h-64 flex-col items-center justify-center gap-2 text-muted-foreground">
        <span>Judge not found</span>
        <Link
          to="/admin/evaluations/$id"
          params={{ id: id }}
          className="text-sm text-primary hover:underline"
        >
          Back to evaluation
        </Link>
      </div>
    )
  }

  return <JudgeProfileView judge={data.data} backTo={`/admin/evaluations/${id}`} />
}
